import { AlphaEBoxIcon } from './AlphaEBoxIcon';

/**
 * author: GreenTurtwig
 * id 15C859D5-210D-4C8B-BB14-7A2B92ADB1C2
 * name alpha-e-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-e-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetEBoxIcon = AlphaEBoxIcon;
export default AlphabetEBoxIcon